module.exports = __webpack_public_path__ + "static/media/FramePuzzlePrizes.65c87aa2.png";